// Ported from project/assets/firm-config.js — per-firm activation.
// Robert's firm has all 13 active. In production this comes from the firm's
// database row keyed by Google Workspace domain.

import type { FirmConfig, MatterTag } from "./types";

export const FIRM_CONFIG: FirmConfig = {
  firmId: "rb-philly",
  firmName: "Law Offices of Robert Bond, Esq.",
  firmCity: "Philadelphia, PA",
  firmDomain: "phillylawcenter.com",
  firmStateBars: ["PA", "NJ"],
  firmAttorney: {
    id: "u-rb",
    initials: "RB",
    name: "Robert Bond",
    role: "Managing Attorney",
    barNo: "PA 312445",
  },

  activePracticeAreas: [
    "ssi",
    "immigration",
    "municipal",
    "wills",
    "family",
    "pi",
    "criminal",
    "traffic",
    "dui",
    "medmal",
    "civil",
    "appeals",
    "bankruptcy",
  ],

  matterTags: [
    { id: "sobel-of-counsel", label: "Sobel of-Counsel" },
    { id: "drew-referral", label: "Drew Referrals" },
    { id: "habeas", label: "Habeas" },
    {
      id: "wc-defense",
      label: "WC Defense (legacy)",
      note: "Closed/archived files only — Robert no longer takes new WC matters",
    },
    { id: "ny-pi", label: "NY PI" },
  ],

  clientLanguages: ["English", "Russian", "Ukrainian", "Spanish"],

  drive: {
    sharedDriveRoot: "/Shared drives/Phillylawcenter",
    inboxFolder: "/Shared drives/Phillylawcenter/DuraLex Inbox",
    formsFolder: "/Shared drives/Phillylawcenter/FORMS",
  },
};

export const firmTagById = (id: string): MatterTag | undefined =>
  FIRM_CONFIG.matterTags.find((t) => t.id === id);
